// extracted by mini-css-extract-plugin
module.exports = {"container":"FY2MHfGQ","title":"trarBajv","text":"peVhkx5M"};